module.exports = __webpack_public_path__ + "img/13d.e0531062.png";